<template>
  <div id="materialDetails" v-loading="isLoadingImg">
    <header-top :headerText="`上传${headerText}`" showBack></header-top>
    <div class="material-tip">
      <svg-icon icon-class="icon-tips" class="icon-tips" />
      <ul>
        <svg-icon icon-class="tips-bg" class="icon-tips-bg" v-if="showTips"/>
        <li class="tips-tit">
          小贴士
          <i
            class="el-icon-caret-top tips-btn"
            v-if="showTips"
            @click="showTip"
          ></i>
          <i class="el-icon-caret-bottom tips-btn" v-else @click="showTip"></i>
        </li>
        <li v-if="showTips">
          <span></span>
          <div
            v-if="
              headerText == '身份证原件照片' ||
              headerText == '学历证明' ||
              headerText == '个人证件照'
            "
          >
            {{ headerText }}必须为员工本人{{ headerText }}，不能上传其他人{{ headerText }}进行代替
          </div>
          <div v-else>
            {{ headerText }}可为pdf、word等格式文件
          </div>
        </li>
        <li v-if="showTips">
          <span></span>
          <div>
            上传{{ headerText }}图片格式建议为JPG或PNG格式；照片文字清晰可见；大小不超过5M
          </div>
        </li>
      </ul>
    </div>
    <div class="main">
      <div class="tit">请上传{{headerText}}资料</div>
      <material-currencyInfo :isLoadingImg="isLoadingImg" @isLoading="loadingImg"></material-currencyInfo>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import materialCurrencyInfo from "./material/material-currency-info";
export default {
  name: "Index",
  components: {
    headerTop,
    materialCurrencyInfo,
  },
  data() {
    return {
      headerText: this.$route.query.type,
      id: this.$route.params.id,
      fileList: [],
      showViewer: -1,
      isLoadingImg:true,
       showTips: true,
    };
  },
  mounted() {
  },
  methods: {
    showTip() {
      this.showTips = !this.showTips;
    },
    loadingImg(val){
      this.isLoadingImg = val
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
.material-tip {
  @include flex(row, flex-start);
  margin: 20px 20px 0;
  padding: 20px 25px;
  font-size: 12px;
  font-weight: 500;
  background: #fff;
  .icon-tips {
    color: $--color-primary;
    padding: 10px 0;
  }
  ul {
    margin: 0;
    position: relative;
    padding-left: 10px;
    width: 100%;
    .icon-tips-bg {
      position: absolute;
      right: 0px;
      bottom: -94px;
      font-size: 250px;
    }
    li {
      @include flex(row, center);
      margin-bottom: 10px;
      width: 100%;
      span {
        display: inline-block;
        margin-right: 5px;
        border-radius: 50%;
        padding: 2px;
        background: #111;
      }
    }
    .tips-tit {
      justify-content: space-between;
      .tips-btn {
        position: relative;
        z-index: 99;
        padding: 10px;
        cursor: pointer;
      }
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
}
.main {
  margin: 20px;
  padding: 26px 19px;
  min-height: calc(100vh - 220px);
  background: #fff;
  .tit {
    margin-bottom: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }

  .update-box {
    @include flex(row, center);
    flex-wrap: wrap;
    .material-info {
      margin-bottom: 20px;
      .card-tit {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666666;
      }
      .material-details {
        @include flex(row, center);
        flex-wrap: wrap;
        justify-content: flex-start;
        .img-list {
          margin-bottom: 30px;
          width: 390px;
          .img-box {
            @include flex(row, flex-end);

            .el-image {
              width: 200px;
              height: 148px;
              text-align: center;
              display: flex;
            align-items: center;
              ::v-deep .el-image__inner {
                width: 200px;
                height: auto;
              }
            }
            ::v-deep .el-image-viewer__close{
              color: #fff;
            }
            .img-info {
              margin-left: 10px;
              margin-bottom: 20px;
              .img-name{
                margin-bottom: 10px;
              }
              .img-btn {
                @include flex(row, center);
                justify-content: space-between;
                margin-top: 10px;
                width: 130px;
                height: 12px;
                line-height: 12px;
                .btn {
                  cursor: pointer;
                  font-size: 12px;
                  color: $--color-primary;
                }
              }
            }
          }
          .upload-tips {
            color: #bbb;
            span {
              font-size: 12px;
              color: $--color-primary;
            }
          }
        }
        // margin-bottom: 12px;
        ::v-deep .el-upload-dragger {
          border: 0;
        }
        ::v-deep .img-list .el-upload {
          border-radius: 0px;
          width: 350px;
          height: 150px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        ::v-deep .el-upload--picture-card {
          margin-right: 40px;
          width: 350px;
          height: 150px;
          border-radius: 0;
          border-color: #ddd;
        }
        .img-list .el-upload:hover {
          border-color: #409eff;
        }

        .avatar {
          @include flex(row, center);
          width: 178px;
          height: 400px;
          img {
            width: 50%;
            height: 100%;
          }
          .img-info {
            width: 100%;
            height: 100%;
          }
        }
      }

      .tips {
        margin-top: 12px;
        font-size: 12px;
        color: #888;
      }
    }
  }
}
// @media (max-width: 1680px) {
//   .main {
//     margin: 20px 50px 0;
//   }
//   .material-tip{
//     margin:20px 50px 0
//   }
// }

// @media (min-width: 1680px) and (max-width: 1920px) {
//   .main {
//     margin: 20px 100px 0;
//   }
//   .material-tip{
//     margin:20px 100px 0
//   }
// }

// @media (min-width: 1920px) {
//   .main {
//     margin: 20px 160px 0;
//   }
//   .material-tip{
//     margin:20px 160px 0
//   }
// }
</style>
